import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { KHOA } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { KHOA_API } from '../../utils/apiUrl.js';

// ------------------------------
// GET ALL KHOA
// ------------------------------
export const khoaGetAllAction = createAsyncThunk(
    KHOA.GET_ALL,
    async (_, { rejectWithValue }) => {
        try {
            const response = await Get(KHOA_API.GET_ALL);
            return response || [];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// GET KHOA PAGING
// ------------------------------
export const khoaPagingAction = createAsyncThunk(
    KHOA.GET_PAGING,
    async (model = {}, { rejectWithValue }) => {
        try {
            const pageIndex = model?.PageIndex ?? model?.pageIndex ?? 1;
            const pageSize = model?.PageSize ?? model?.pageSize ?? 20;
            const keyword = model?.Keyword ?? model?.keyword ?? '';

            const params = new URLSearchParams({
                Keyword: keyword,
                PageIndex: pageIndex,
                PageSize: pageSize
            });

            const url = `${KHOA_API.GET_PAGING}?${params.toString()}`;
            const response = await Get(url);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// GET ITEM
// ------------------------------
export const khoaGetItemAction = createAsyncThunk(
    KHOA.GET_ITEM,
    async (id, { rejectWithValue }) => {
        try {
            const response = await Get(KHOA_API.GET_ITEM(id));
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// ADD / EDIT / DELETE
// ------------------------------
export const addKhoaAction = createAsyncThunk(
    KHOA.ADD_KHOA,
    async (model, { rejectWithValue }) => {
        try {
            const res = await Post(KHOA_API.ADD_ITEM, null, model, false);
            return res.status;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const editKhoaAction = createAsyncThunk(
    KHOA.EDIT_KHOA,
    async (model, { rejectWithValue }) => {
        try {
            const res = await Put(KHOA_API.UPDATE_ITEM(model.id), null, model.data);
            return res.status;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const deleteKhoaAction = createAsyncThunk(
    KHOA.DELETE_KHOA,
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const res = await DeleteSingle(KHOA_API.DELETE_ITEM(id));
            if (res.status === 200) return fulfillWithValue(res.status);
            const errJson = await res.json();
            return rejectWithValue(errJson);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// SYNC KHOA
// ------------------------------
export const syncKhoaAction = createAsyncThunk(
    KHOA.SYNC_KHOA,
    async (apiUrl = null, { rejectWithValue }) => {
        try {
            const url = apiUrl
                ? `${KHOA_API.SYNC_KHOA}?apiUrl=${encodeURIComponent(apiUrl)}`
                : KHOA_API.SYNC_KHOA;
            const response = await Post(url, null, null, false);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// INITIAL STATE
// ------------------------------
const initialState = {
    listKhoa: [],
    totalKhoa: 0,
    khoaItem: null
};

// ------------------------------
// SLICE
// ------------------------------
export const khoaSlice = createSlice({
    name: KHOA.NAME_SLICE,
    initialState,
    reducers: {
        filterListKhoa: (state, action) => {
            state.listKhoa = state.listKhoa.filter(x => x.id !== action.payload);
            state.totalKhoa -= 1;
        }
    },
    extraReducers: (builder) => {
        builder
            // GET ALL
            .addCase(khoaGetAllAction.fulfilled, (state, action) => {
                state.listKhoa = action.payload || [];
            })
            .addCase(khoaGetAllAction.rejected, (state) => {
                state.listKhoa = [];
            })

            // PAGING
            .addCase(khoaPagingAction.fulfilled, (state, action) => {
                state.listKhoa = action.payload?.data || [];
                state.totalKhoa = action.payload?.totalRecords || 0;
            })
            .addCase(khoaPagingAction.rejected, (state) => {
                state.listKhoa = [];
                state.totalKhoa = 0;
            })

            // GET ITEM
            .addCase(khoaGetItemAction.fulfilled, (state, action) => {
                state.khoaItem = action.payload;
            })
            .addCase(khoaGetItemAction.rejected, (state) => {
                state.khoaItem = null;
            });
    }
});

export const { filterListKhoa } = khoaSlice.actions;
export default khoaSlice.reducer;
